import Script from 'next/script';
import getConfig from 'next/config';

import { bugsnag } from 'shared/utils/services/bugsnag';

declare global {
  interface Window {
    OptanonActiveGroups: any;
  }
}

interface IOneTrustScriptProps {
  cspNonce: string;
}

export const OneTrustScript = ({ cspNonce }: IOneTrustScriptProps) => {
  const {
    publicRuntimeConfig: { RELEASE_ENV },
  } = getConfig();

  const dataDomainScript =
    RELEASE_ENV === 'production'
      ? '1ba2b3d9-51ab-4bf3-8d29-9aaec1d64c11'
      : '1ba2b3d9-51ab-4bf3-8d29-9aaec1d64c11-test';

  return (
    <>
      {/* Restores display:flex on the otFlat banner container. OneTrust's
          template stopped emitting it, which collapsed the flex layout and
          clipped banner content. Remove once fixed in the OneTrust template. */}
      <style
        nonce={cspNonce}
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{
          __html: `#onetrust-banner-sdk.otFlat { display: flex; }`,
        }}
      />
      <Script
        id="onetrust-script-1"
        key="oneTrust"
        src="https://cdn.cookielaw.org/scripttemplates/otSDKStub.js"
        data-domain-script={dataDomainScript}
        nonce={cspNonce}
        strategy="lazyOnload"
      />
      <Script
        id="onetrust-script-2"
        key="oneTrustWrapper"
        nonce={cspNonce}
        onError={(error) => {
          bugsnag(error, { context: 'OneTrust Inline Script Erroring' });
        }}
        strategy="lazyOnload"
      >
        {`
          function OptanonWrapper() {}
        `}
      </Script>
    </>
  );
};
